import { Box, Grid, Typography } from "@mui/material";
import { isExistsCookies } from "utils/cookies";
import { HomePageCalendar } from "../components/HomePageCalendar";
import { HomePageDocumentation } from "../components/HomePageDocumentation";
import { HomePageSignIn } from "../components/HomePageSignIn";

export function HomePage() {
    const isAuthenticated = isExistsCookies();
    return (
        <div>
            <div className="home-page-banner">
                <Box className="home-page-banner-content">
                    <img
                        height="100px"
                        width="100px"
                        className="home-page-banner-content-logo"
                        src="/assets/images/banner-logo.webp"
                        alt="logo"
                    />
                    <Typography
                        variant="h4"
                        component="h4"
                        className="home-page-banner-content-text-welcome"
                    >
                        Selamat Datang di Portal
                    </Typography>
                    <Typography
                        variant="h2"
                        component="h1"
                        className="home-page-banner-content-title"
                    >
                        Layanan Pengolahan Lumpur Tinja
                    </Typography>
                    <Typography
                        variant="body1"
                        component="p"
                        className="home-page-banner-content-text"
                    >
                        Layanan Lumpur Tinja Terjadwal (LLTT) adalah layanan
                        penyedotan lumpur tinja dari tangki septik yang
                        dilakukan secara berkala. Dalam LLTT Penyedotan
                        dilakukan secara periodik, yakni sekitar 2-5 tahun
                        sekali. Hasil sedot tinja kemudian dibawa ke IPLT
                        (Instalasi Pengolahan Lumpur Tinja) untuk diolah.
                        Menguras tangki septik yang benar harus dilakukan secara
                        rutin dan berkala. Tangki septik yang sudah pernuh akan
                        rawan bocor sehingga air limbah domestilk dapat meluap
                        dan mencemari lingkungan.
                    </Typography>
                </Box>
            </div>
            <div className="home-page-content-1">
                {isAuthenticated ? (
                    <Grid container spacing={3}>
                        <Grid item lg={12}>
                            <HomePageDocumentation />
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={12}>
                            <HomePageDocumentation />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <HomePageSignIn />
                        </Grid>
                    </Grid>
                )}
            </div>
            <div className="home-page-content-2">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <HomePageCalendar />
                    </Grid>
                </Grid>
            </div>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <img
                        src="/assets/images/bottom-homepage.webp"
                        style={{ maxWidth: "100%" }}
                        alt="bottom-homepage"
                    />
                </Grid>
            </Grid>
        </div>
    );
}
